import ListViewContainer from "../../../../Components/Miscellaneous/JobSearch/ListView/ListViewContainer";

const ListView = () => {
  return <ListViewContainer />;
};

export default ListView;
